import { Product } from '../../lib/types/models/product/product'
import { ProductInput } from '../../lib/types/models/product/product-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateProduct(data: UpdateInput<ProductInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.products.update.url, { id }))
    .patch<Product, Partial<ProductInput>>(rest)
}
